import { render, staticRenderFns } from "./T1FooterAddons.vue?vue&type=template&id=32136038&scoped=true&"
import script from "./T1FooterAddons.vue?vue&type=script&lang=js&"
export * from "./T1FooterAddons.vue?vue&type=script&lang=js&"
import style0 from "./T1FooterAddons.vue?vue&type=style&index=0&id=32136038&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32136038",
  null
  
)

export default component.exports